import React, { Component } from 'react';
import './Home.scss';
import {Link, useMatches } from "react-router-dom";
import request from "../../Ajax";

export default class Home extends Component {

    constructor(props) {
        super(props);
        this.inner_state = {
            labels: 'getLabels',
        };

        this.state = {
            labels: [],
            lang: this.props.match.params.lang === 'en' ? 2 : 1
        };

    }

    componentDidMount() {
        request(
            this.inner_state.labels,
            'post',
            { 'page_type' : 'heading', 'lang' : this.state.lang },
            (response) => {
                if (response.data.status === true) {
                    this.setState({ labels: response.data.data });
                } else {
                    //todo chgitem inch erb labelneri het kapvac xndir ka
                }
            }
        );
    }


  render() {
    const link = `/insurance${this.props.match.params.lang ? "/" + this.props.match.params.lang : ''}`
    return (
      <div className="row align-center">
        <div className="column small-12 large-10">

          <div className="main_page homepage">
            <div className="row align-middle">
              <div className="column small-12">
                <div className="base_grid_container">
                  <div className="title-lg text-uppercase custom-headline main_page_title">
                    <h1>
                        { this.state.labels.title}
                    </h1>
                  </div>

                  <div className="main_page_link">
                    <Link to={link} className="btn btn-green btn-lg">
                        { this.state.labels.button}
                    </Link>
                  </div>

                  <div className="main_page_img">
                    <img src={require("../../assets/img/business.png")} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}
